import './style.scss'

const Loading = () => <div className="loading-style" />

export default Loading
